import axios from 'axios'

export default class {
  get (url, params = {}) {
    return axios({ method: 'GET', url, ...params })
  }

  post (url, params = {}) {
    return axios({ method: 'POST', url, ...params })
  }

  delete (url, params = {}) {
    return axios({ method: 'DELETE', url, ...params })
  }

  put (url, params = {}) {
    return axios({ method: 'PUT', url, ...params })
  }
}
